// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"293":"component---src-pages-index-js","453":"d7eeaac4","631":"d0c16330"}[chunkId] + "-" + {"293":"ebfd42f60366f877519c","453":"b4c646b07cbdbc74f577","631":"a738deb583d0d92dc7b2"}[chunkId] + ".js";
};